<script>
import Component from '~/sites/oknanebodvere/pages/login'
export default {
  extends: Component,
  nuxtI18n: {
    paths: {
      cs: '/prihlasit',
      en: '/login',
      sk: '/prihlasit',
    },
  },
  methods: {
    checkRouteAccess() {},
  },
}
</script>
